import React from 'react';
import SaveAlt from '@mui/icons-material/SaveAlt';
import Button, { type ButtonProps } from '@mui/material/Button';
import classnames from 'classnames';
import useMobileView from '@/hooks/ui/useMobileView';
import translate from '@/lib/intl/translate';

export default function ExportButton({
  onClick,
  type = 'button',
  ...buttonProps
}: ButtonProps) {
  const isMobile = useMobileView();
  return (
    <Button
      classes={{
        /**
         * This button has some weird layout issues on mobile with its
         * default styling. We only want these styles on mobile, so just going
         * to use isMobile to achieve them.
         */
        startIcon: classnames({ 'mx-0 -mt-1': isMobile }),
      }}
      type={type}
      onClick={onClick}
      title={translate('EXPORT')}
      {...buttonProps}
    >
      <span className="hidden md:inline">
        <SaveAlt />
      </span>
    </Button>
  );
}
